// Drawer.js — sağdan İÇERİĞİN ÜSTÜNE kayan detay paneli.
// Eski DetailPanel'in aksine listeyi sıkıştırmaz; ESC / backdrop / ✕ ile kapanır.
import React from 'react';
import { usePencereKapat, KapatX } from './pencereKapat';
import { vw } from '../yaziBoyutu';

export default function Drawer({ title, subtitle, onClose, width = 640, footer, children }) {
  // ESC artık ortak yığından (12 Eki 2026): iç içe pencerede yalnız en üstteki kapanır.
  usePencereKapat(onClose);

  return (
    <>
      <div className="drawer-backdrop" onClick={onClose} />
      <div className="drawer" style={{ width: `min(${width}px,${vw(100)})` }} role="dialog" aria-modal="true">
        <div style={{ padding: '14px 20px', borderBottom: '1px solid var(--border)', display: 'flex', alignItems: 'center', gap: 12, flexShrink: 0 }}>
          <div style={{ flex: 1, minWidth: 0 }}>
            <div style={{ fontSize: 15, fontWeight: 700, color: 'var(--t1)', fontFamily: 'var(--mono)', letterSpacing: 1, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
              {title}
            </div>
            {subtitle && (
              <div style={{ fontSize: 11, color: 'var(--t3)', marginTop: 2, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                {subtitle}
              </div>
            )}
          </div>
          <KapatX onClose={onClose} />
        </div>
        <div style={{ flex: 1, overflowY: 'auto', minHeight: 0 }}>{children}</div>
        {footer && (
          <div style={{ padding: '12px 20px', borderTop: '1px solid var(--border)', display: 'flex', gap: 10, flexShrink: 0, background: 'var(--bg3)' }}>
            {footer}
          </div>
        )}
      </div>
    </>
  );
}
